import { TiktokLogo, FacebookLogo, WhatsappLogo, ArrowUpRight } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";
import { BRAND, WHATSAPP_NUMBER, TIKTOK_URL, FACEBOOK_URL, waLink } from "../../data/site";

export const Footer = () => (
    <footer data-testid="footer" className="border-t border-border bg-surface/40">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 pt-24 pb-10">
            <div className="grid lg:grid-cols-12 gap-12 pb-20">
                <div className="lg:col-span-6">
                    <Reveal>
                        <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-accent">
                            Sedia untuk menempah?
                        </span>
                        <p className="mt-5 font-display text-3xl md:text-4xl text-ink max-w-lg leading-tight tracking-tight">
                            Mari bina astana idaman untuk si comel anda hari ini.
                        </p>
                        <a
                            href={waLink("Hai ASTANA KUCING'S, saya ingin membuat tempahan / bertanya.")}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-whatsapp-cta"
                            className="mt-8 inline-flex items-center gap-2 rounded-full bg-accent px-7 py-3.5 text-sm font-semibold text-white hover:bg-accent-hover transition-colors duration-300"
                        >
                            <WhatsappLogo size={19} weight="fill" />
                            WhatsApp Kami
                        </a>
                    </Reveal>
                </div>

                <div className="lg:col-span-3">
                    <h4 className="font-mono text-[11px] uppercase tracking-[0.28em] text-ink-soft">
                        Hubungi
                    </h4>
                    <ul className="mt-6 space-y-3">
                        <li>
                            <a
                                href={waLink("Hai ASTANA KUCING'S")}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-whatsapp-number"
                                className="text-ink hover:text-accent transition-colors duration-300"
                            >
                                +{WHATSAPP_NUMBER}
                            </a>
                        </li>
                        <li className="text-ink-soft text-sm">Isnin – Sabtu · 9pg – 7ptg</li>
                        <li className="text-ink-soft text-sm">Malaysia</li>
                    </ul>
                </div>

                <div className="lg:col-span-3">
                    <h4 className="font-mono text-[11px] uppercase tracking-[0.28em] text-ink-soft">
                        Ikuti Kami
                    </h4>
                    <ul className="mt-6 space-y-3">
                        {[
                            { label: "TikTok", href: TIKTOK_URL, Icon: TiktokLogo, id: "tiktok" },
                            { label: "Facebook", href: FACEBOOK_URL, Icon: FacebookLogo, id: "facebook" },
                        ].map(({ label, href, Icon, id }) => (
                            <li key={label}>
                                <a
                                    href={href}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid={`footer-${id}`}
                                    className="group inline-flex items-center gap-2 text-ink hover:text-accent transition-colors duration-300"
                                >
                                    <Icon size={18} weight="fill" />
                                    {label}
                                    <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="border-t border-border pt-10">
                <h2 className="font-display text-[15vw] leading-none tracking-tight text-ink/90 select-none">
                    ASTANA <span className="text-accent italic">KUCING'S</span>
                </h2>
                <p className="mt-8 text-sm text-ink-soft">
                    © {new Date().getFullYear()} {BRAND}. Hak cipta terpelihara. Dibina
                    dengan kasih untuk kucing Malaysia.
                </p>
            </div>
        </div>
    </footer>
);
